import * as React from "react";
import { ThemePaletteState, } from "../../../theme/_Types";
import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
import { Icon, IconNames } from "./Icon";
/**
 *
 */
var createPlaceholderChildren = function () {
    var placeholderChildren = [];
    for (var i = 2; i < 14; i++) {
        placeholderChildren.push(React.createElement("div", { key: "placeholder ".concat(i), className: "scl-a-loader-placeholder__load-effect le-".concat(i) }));
    }
    return placeholderChildren;
};
/**
 * LoadingIndications define the types of loading indicators supported by the
 * LoadingIndicator component. They specify the context of the loading operation
 * for which it is to give feedback.
 */
export var LoadingIndications;
(function (LoadingIndications) {
    LoadingIndications["GLOBAL"] = "APP";
    LoadingIndications["DEFAULT"] = "INDICATOR";
    LoadingIndications["PLACEHOLDER"] = "PLACEHOLDER";
})(LoadingIndications || (LoadingIndications = {}));
/**
 *
 * @param props
 */
var LoadingIndicatorComp = function (props) {
    var _a;
    // render the correct components
    switch (props.type) {
        case LoadingIndications.DEFAULT:
            var indicatorClassName = "scl-a-loader-indicator ".concat((_a = props.className) !== null && _a !== void 0 ? _a : "");
            return (React.createElement("div", { className: indicatorClassName },
                React.createElement("div", { className: "scl-a-loader-indicator__content" },
                    React.createElement("div", { className: "scl-a-loader-indicator__animation" }),
                    React.createElement("div", { className: "scl-a-loader-indicator__label" }, props.children))));
        case LoadingIndications.PLACEHOLDER:
            var placeHolderClassName = "scl-a-loader-placeholder";
            return (React.createElement("div", { className: placeHolderClassName },
                React.createElement("div", { className: "scl-a-loader-placeholder__load-effect-holder" }, createPlaceholderChildren())));
        case LoadingIndications.GLOBAL:
            var appClassName = joinClasses("scl-a-loader-app", props.className);
            return (React.createElement("div", { className: appClassName },
                React.createElement("div", { className: "scl-a-loader-app__content scl-h-animation--grow-in-out-repeat" },
                    React.createElement(Icon, { name: IconNames.BOLT, theme: { paletteState: ThemePaletteState.WARNING }, className: "scl-a-loader-app__content--icon" }))));
        default:
            return null;
    }
};
/**
 *
 */
export var LoadingIndicator = asThemeConsumer(LoadingIndicatorComp);
